function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M3.75 3.75h16.5v16.5H3.75z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.252 15.316h.067v-3.128h1.437v3.867h-.013V16.752H7.237V7.248h1.437v8.069h6.578z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.134
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.749 12.054V7.247h1.436v4.807H13.75z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.134
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.869 7.18h-1.571v6.511h3.383v-1.57H11.87V7.18z",
  fill: "currentColor"
});

function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgLogoIcon;